module.exports = __webpack_public_path__ + "static/img/zhao.c679db1.png";


//////////////////
// WEBPACK FOOTER
// ./static/zhao.png
// module id = fIWt
// module chunks = 7